"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BasePinComponentSettingsSchema = exports.BasePinComponentSchema = exports.PinComponentLayoutSchema = exports.LineSchema = exports.BoxSchema = exports.SizeSchema = exports.VectorSchema = void 0;
const zod_1 = require("zod");
exports.VectorSchema = zod_1.z.object({
    x: zod_1.z.number(),
    y: zod_1.z.number(),
});
exports.SizeSchema = zod_1.z.object({
    width: zod_1.z.number(),
    height: zod_1.z.number(),
});
exports.BoxSchema = zod_1.z.object({
    type: zod_1.z.literal('BOX'),
    position: exports.VectorSchema,
    size: exports.SizeSchema,
    rotation: zod_1.z.number(),
    lockAspectRatio: zod_1.z.boolean().optional(),
});
exports.LineSchema = zod_1.z.object({
    type: zod_1.z.literal('LINE'),
    start: exports.VectorSchema,
    end: exports.VectorSchema,
});
exports.PinComponentLayoutSchema = zod_1.z.discriminatedUnion('type', [exports.BoxSchema, exports.LineSchema]);
exports.BasePinComponentSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    layout: exports.PinComponentLayoutSchema,
    order: zod_1.z.string(),
});
exports.BasePinComponentSettingsSchema = zod_1.z.object({
    movableInInteractiveViewer: zod_1.z.boolean().nullish(),
    lockLayout: zod_1.z.boolean().nullish(),
});
//# sourceMappingURL=base-pin-component.js.map